module.exports = __webpack_public_path__ + "img/Logo-Dycar.74b65fb7.webp";